export default __webpack_public_path__ + "static/media/88.bfac7e79.jpg";